import { Formik } from "formik";
import { Button, Col, Form, Row } from "react-bootstrap";
import {
  attPreSinAnt,
  attPregestacionalOpt,
  noAplicaOpt,
  noSiOpt,
  opt123,
  primeraVezSubsecuentaOpt,
  inicialSubsecuentaOpt,
  sintomaDepresivaOpt,
  referidoPorOpt,
} from "./constants/options";
import Controller from "./controller/Controller";
import { Fragment, useContext, useState ,useEffect} from "react";
import * as Yup from "yup";
import Post from "../../../api/Post";
import { MEDICAL_HISTORY_MX } from "../../../api/Routes";
import { authContext } from "../../../context/AuthContext";
import Put from "../../../api/Put";
import SimpleLoad from "../../../loader/SimpleLoad";
import Get from "../../../api/Get";
const fields1 = [
  {
    name: "informaPrevencionAccidentes",
    type: "select",
    label: "Prevención de accidentes",
    options: [...noAplicaOpt, ...noSiOpt],
  },
  
];

const fields2 = [
  {
    name: "contrarreferido",
    type: "select",
    label: "Referido por",
    options: [...noAplicaOpt, ...noSiOpt],
  },
  {
    name: "telemedicina",
    type: "select",
    label: "Telemedicina",
    options: [...noAplicaOpt, ...noSiOpt],
  },
];

export default function AccidentPrevention({
  setShowModalServer,
  setErrorServer,
  setShowSuccess,
  citaId,
  prevencionAccidentes,
  validationData,
}) {
  const { auth } = useContext(authContext);
  const [isSubmiting, setSubmiting] = useState(false);
  const [id, setId] = useState(null);
  const schema = Yup.object().shape({
    informaPrevencionAccidentes: Yup.number()
        .test(
          'informaPrevencionAccidentes',
          'Valor inválido',
          function (value) {
            const { age, speciality } = validationData;
            if (age.years < 10 && speciality !== 15 && speciality !== 16) {
              return value === 0 || value === 1;
            } else {
              return value === -1;
            }
          }
        ),
  });
  const [initValues, setInitValues] = useState(prevencionAccidentes);

  useEffect(() => {
    if (initValues?.id) {
      setSubmiting(true);
      Get({
        url: `${MEDICAL_HISTORY_MX}/find-accident-prevention/${initValues.id}`,
        access_token: auth.data.access_token,
      })
        .then((response) => {
          setInitValues(response.data);
          setSubmiting(false);
        })
        .catch((error) => {
          console.log(error);
          setSubmiting(false);
        });
    }
  }, [initValues?.id, auth.data.access_token]);
  return (
    <>
      <Formik
        initialValues={initValues
          ? initValues
          : {
          appointmentId: citaId,
          informaPrevencionAccidentes: "-1",
         
        }}
        validationSchema={schema}
        enableReinitialize
        onSubmit={async (values, { setSubmitting, setFieldValue }) => {
          setSubmiting(true);
          if (id) {
            const body = {
              id,
              ...values,
            };
            try {
              const response = await Put({
                url: `${MEDICAL_HISTORY_MX}/update-accident-prevention/`,
                data: body,
                access_token: auth.data.access_token,
                header: true,
              });
              console.log(response);
              setSubmiting(false);
              setTimeout(() => {
                setShowSuccess(false);
              }, 2000);
            } catch (error) {}
          } else {
            try {
              const response = await Post({
                url: `${MEDICAL_HISTORY_MX}/save-accident-prevention/`,
                data: values,
                access_token: auth.data.access_token,
                header: true,
              });
              console.log(response);
              setId(response.data.id);
              setSubmiting(false);
              setTimeout(() => {
                setShowSuccess(false);
              }, 2000);
            } catch (error) {
              setSubmiting(false);
              setShowModalServer(true);
              if (error.response) {
                setErrorServer(error.response);
              }
            }
          }
          console.log(values);
        }}
      >
        {({ values, errors, handleChange, handleSubmit, setFieldValue }) => (
          <Form onSubmit={handleSubmit}>
            {isSubmiting && <SimpleLoad />}
            <Row>
              <Col xs="12" md="6">
                <dl className="row">
                  {fields1.map((it) => (
                    <Fragment key={it.name}>
                      <dt className="col-sm-5">{it.label}</dt>
                      <dd className="col-sm-7">
                        <Controller
                          type={it.type}
                          name={it.name}
                          errors={errors}
                          onChange={handleChange}
                          options={it.options}
                        />
                      </dd>
                    </Fragment>
                  ))}
                </dl>
              </Col>

            </Row>
            <hr />
            <Row>
              <Col className="text-right">
                <Button
                  variant="outline-success"
                  className="ok-buttom"
                  type="submit"
                >
                  Guardar
                </Button>
              </Col>
            </Row>
          </Form>
        )}
      </Formik>
    </>
  );
}
